import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import B from 'bem-cn';
import getStaticContent from '../../utils/getStaticContent';
import AppBar from 'react-toolbox/lib/app_bar';
import Navigation from 'react-toolbox/lib/navigation';
import { Button } from 'react-toolbox/lib/button';
import { Tab, Tabs } from 'react-toolbox';
import classes from 'classnames';

import './header.scss';

import { scrollToElement } from '../../utils/scroll';

const cl = B('Header');
const SCROLL_BORDER = 10;

const menuItems = [
  {
    label: 'Solution',
    href: '#solution'
  },
  {
    label: 'Benefits',
    href: '#benefits'
  },
  {
    label: 'Examples',
    href: '#examples'
  },
  {
    label: 'Vision',
    href: '#vision'
  },
  {
    label: 'Technology',
    href: '#technology'
  },
  {
    label: 'German version',
    href: '/de/akingo/'
  },
  {
    label: 'Contact',
    overlay: 'forms__contactForm'
  },
  {
    label: 'Investors',
    overlay: 'forms__investorRelations'
  },
  {
    label: 'Careers',
    href: '#careers'
  },
  {
    label: 'News Blog',
    href: '#news'
  }
];

const MOBILE_DEVICES = ['phone', 'medium'];

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubmenu: false,
      tabIndex: 1
    };
    this.scrollHandler = this.scrollHandler.bind(this);
    this.staticContent = getStaticContent('header', props.currentPageName);
  }

  static propTypes = {
    setOverlay: PropTypes.func.isRequired,
    displayType: PropTypes.string,
    showedOverlay: PropTypes.string.isRequired,
    currentPageName: PropTypes.string.isRequired
  };

  componentDidMount() {
    document.addEventListener('scroll', this.scrollHandler);

    if (document.location.hash) {
      setTimeout(() => {
        scrollToElement(document.location.hash);
      }, 300);
      this.changeMenuOnHash();
    }

    if (!MOBILE_DEVICES.includes(this.props.displayType)) {
      this.state = {
        showSubmenu: true
      };
    }

    window.addEventListener('hashchange', this.changeMenuOnHash, false);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.showedOverlay &&
      this.props.showedOverlay &&
      !MOBILE_DEVICES.includes(nextProps.displayType)
    ) {
      this.state = {
        showSubmenu: true
      };
    }
    if (
      MOBILE_DEVICES.includes(nextProps.displayType) &&
      !MOBILE_DEVICES.includes(this.props.displayType)
    ) {
      this.state = {
        showSubmenu: false
      };
    }
    if (
      !MOBILE_DEVICES.includes(nextProps.displayType) &&
      MOBILE_DEVICES.includes(this.props.displayType)
    ) {
      this.state = {
        showSubmenu: true
      };
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('hashchange', this.changeMenuOnHash, false);
  }

  changeMenuOnHash = () => {
    if (document.location.hash) {
      let itemIndex = null;
      menuItems.forEach((item, index) => {
        if (item.href && item.href === document.location.hash) {
          itemIndex = index;
        }
      });
      if (itemIndex !== null) {
        this.handleTabChange(itemIndex);
      }
    }
  };

  scrollHandler = () => {
    if (['phone', 'medium'].includes(this.props.displayType)) {
      return;
    }
    const currentScroll = parseInt(
      document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset,
      10
    );
    if (currentScroll > SCROLL_BORDER) {
      this.setState({
        showSubmenu: false
      });
    } else {
      this.setState({
        showSubmenu: true
      });
    }
  };

  onClick = () => {
    const { showSubmenu } = this.state;
    if (!showSubmenu) {
      this.changeMenuOnHash();
    }
    this.setState({
      showSubmenu: !showSubmenu
    });
  };

  setOverlay = (e, overlay) => {
    e.preventDefault();
    const { setOverlay } = this.props;

    setOverlay(overlay);
  };

  handleAnchorClick = e => {
    const { showSubmenu } = this.state;
    const el = e.currentTarget;
    const href = el.getAttribute('href');
    const checkHash = href.indexOf('#');
    if (checkHash === 0) {
      e.preventDefault();
      scrollToElement(href.substr(checkHash));
      location.hash = href.substr(checkHash);

      // Close submenu if showed
      if (showSubmenu) {
        this.setState({
          showSubmenu: false
        });
      }
    }
  };

  handleTabChange = index => {
    if (!menuItems[index].overlay) {
      this.setState({ tabIndex: index });
    } else {
      this.setState({
        showSubmenu: false
      });
    }
  };

  render() {
    const { tabIndex, showSubmenu } = this.state;

    return (
      <div>
        <AppBar
          theme={{
            leftIcon: cl('toggleMenuButton'),
            appBar: cl('appBar')
          }}
          leftIcon={<div className={cl('menuIcon')} />}
          onLeftIconClick={this.onClick}
        >
          <Navigation type="horizontal">
            <div className={cl('logo')}>
              <Link to={prefixLink('/')}>
                <span>AKINGO</span>
                <span>{this.staticContent.title}</span>
              </Link>
            </div>

            <div className={cl('subtitle')}>
              {this.staticContent.subtitle}
            </div>
          </Navigation>

          <div className={cl('requestDemoButtonContainer')}>
            <Button
              className={cl('requestDemoButton').toString()}
              onMouseUp={e => this.setOverlay(e, 'forms__requestDemo')}
              raised
            >
              Request Demo
            </Button>
          </div>
        </AppBar>
        {showSubmenu &&
          <Tabs
            index={tabIndex}
            onChange={this.handleTabChange}
            inverse
            className={cl('subMenu')()}
            style={{ position: 'absolute', top: '6.4rem', zIndex: 1 }}
          >
            {menuItems.map((item, index) => {
              if (item.href) {
                return (
                  <Tab
                    key={index}
                    label={item.label}
                    onClick={this.handleAnchorClick}
                    href={item.href}
                    className={classes({
                      [cl('subMenu')('item-active')]: index === tabIndex
                    })}
                  />
                );
              } else {
                return (
                  <Tab
                    key={index}
                    label={item.label}
                    onClick={e => this.setOverlay(e, item.overlay)}
                  />
                );
              }
            })}
          </Tabs>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/header/header.jsx